'use client';

import { Suspense } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import QuickAccess from './components/QuickAccess';
import TestimonialCarousel from './components/TestimonialCarousel';
import NewsletterSignup from './components/NewsletterSignup';
import Footer from './components/Footer';

export default function Homepage() {
  return (
    <div className="min-h-screen bg-background">
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <Header />
        <HeroSection />
        <FeaturedContent />
        <QuickAccess />
        <TestimonialCarousel />
        <NewsletterSignup />
        <Footer />
      </Suspense>
    </div>
  );
}